import React from 'react';
import withIcon from '../utilities/withIcon';

const IconTablet = () => {
  return (
    <g>
      <path d="m13.1072.1226h-10.2144a1.7021 1.7021 0 0 0 -1.7 1.7v12.3546a1.7021 1.7021 0 0 0 1.7 1.7h10.2144a1.7021 1.7021 0 0 0 1.7-1.7v-12.3544a1.7021 1.7021 0 0 0 -1.7-1.7002zm-10.2144 1.4h10.2144a.3.3 0 0 1 .3.3v.9074h-10.8142v-.9072a.3.3 0 0 1 .2998-.2999zm10.5142 2.6074v6.6455h-10.814v-6.6455zm-.3 10.3467h-10.2142a.3.3 0 0 1 -.3-.3v-2.001h10.8142v2.001a.3.3 0 0 1 -.2998.3004z" />
      <path d="m8.886 12.6216h-1.7715a.7.7 0 1 0 0 1.4h1.7715a.7.7 0 1 0 0-1.4z" />
    </g>
  );
};

export default withIcon(IconTablet);
